module.exports = __webpack_public_path__ + "img/75616.3ffd38bc.svg";